<template>
  <div class="container">
    <vue-headful title="ABL Groupe | Realisations" />
    <h2>Metropolitain, Paris</h2>
    <section class="realisation--section">
      <div class="realisation--content">
        <div class="realisation--picture col-xs-12 col-md-5">
          <img :src="require('../../assets/images/metro-couloir.jpg')"/>
        </div>

        <div class="realisation--description col-xs-12 col-md-5">

            <h3>Nez de marche antidérapante en acier inoxydable étiré à froid</h3>
            <div>
              <p>Section: 57 x 33 x 3 mm</p>
              <p>Matière : AISI 304L</p>
              <p>Architecte : RATP</p>
            </div>
          <img :src="require('../../assets/images/industry-architecture.jpg')"/>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "NonSlipSteelStairNosing"
}
</script>

<style lang="scss">
.realisation--description {
  & img:last-of-type {
    margin-top: auto;
    width: 100%;
    object-fit: cover;
  }
}
</style>